export const __DEV__ = process.env.NODE_ENV === 'development';
